export const scrumQuestions = [
   {
      id: 1,
      question: "What are the key roles in Scrum?",
      parts: [
         {
            type: "text",
            content: `**Scrum Roles**

**Product Owner**
- 🎯 Vision, backlog, prioritization, stakeholder comms
- ✅ Accepts work; maximizes product value

**Scrum Master**
- 🧭 Facilitates process; removes impediments
- 👩‍🏫 Coaches team; shields from disruptions

**Development Team**
- 👥 Cross-functional, self-organizing (3–9)
- 📈 Estimates and delivers; no sub-roles`
         }
      ]
   },
   {
      id: 2,
      question: "Explain the Scrum ceremonies/events",
      parts: [
         {
            type: "text",
            content: `**Scrum Events**

- 🗓️ Sprint Planning (2–4h): sprint goal, select backlog
- ⏱️ Daily Standup (15m): done/doing/blockers
- 🎥 Sprint Review (1–2h): demo, feedback, adapt backlog
- 🔄 Retrospective (1–1.5h): improve process
- 🧰 Backlog Refinement: ongoing clarification/estimation`
         }
      ]
   },
   {
      id: 3,
      question: "What is a Sprint and what are its characteristics?",
      parts: [
         {
            type: "text",
            content: `**Sprint Characteristics**

- ⏳ Time-boxed iteration (typically 2 weeks)
- 🔐 Protect sprint goal; scope negotiable with PO
- 📅 Daily standups; maintain quality
- 📦 Output: potentially shippable increment, updated backlog, lessons learned
- ❌ Only PO can cancel if goal becomes obsolete`
         }
      ]
   },
   {
      id: 4,
      question: "What is the difference between Scrum and Kanban?",
      parts: [
         {
            type: "text",
            content: `**Scrum vs Kanban**

**Scrum**
- 🗓️ Sprints, committed work, defined roles
- 📊 Estimation, velocity, ceremonies, sprint backlog

**Kanban**
- 🔁 Continuous flow, flexible roles
- ⏱️ Lead/cycle time, WIP limits, pull-based

Choose based on release cadence and team needs; both emphasize transparency and improvement.`
         }
      ]
   },
   {
      id: 5,
      question: "What is the Definition of Done (DoD)?",
      parts: [
         {
            type: "text",
            content: `**Definition of Done (DoD)**

Shared criteria for 'done':
- 🧑‍💻 Code written/reviewed
- ✅ Tests pass
- 📚 Docs updated
- 🔀 Merged to main
- 🚀 Deployed to staging
- 📋 Acceptance criteria met
- 👍 PO approval
- 🧼 No known defects

Ensures quality and transparency; DoD is general, acceptance criteria are story-specific.`
         }
      ]
   },
   {
      id: 6,
      question: "How do you estimate in Scrum?",
      parts: [
         {
            type: "text",
            content: `**Estimating in Scrum**

- 🃏 Planning Poker (Fibonacci)
- 🧮 Story Points (relative effort)
- 👕 T-Shirt sizes (coarse)
- ⏲️ Time-based (less recommended)

Best: estimate as a team, use history, re-estimate when understanding changes; focus on relative sizing for planning conversations.`
         }
      ]
   },
   {
      id: 7,
      question: "What happens in Scrum if estimate or complexity is not calculated correctly?",
      parts: [
         {
            type: "text",
            content: `**When Estimates Miss**

During sprint:
- 💬 Discuss with PO; re-estimate
- 🔽 Drop lower-priority items; protect sprint goal

Next planning:
- 📈 Use velocity data
- ✂️ Split stories smaller; analyze misses

Retro:
- 🔧 Improve refinement/estimation

Guidance: treat estimates as learning tools, not commitments; prefer under-commit; common causes include unclear requirements and hidden dependencies.`
         }
      ]
   },
   {
      id: 8,
      question: "Explain Scrum ceremonies in a few words",
      parts: [
         {
            type: "text",
            content: `**Ceremonies — TL;DR**

- Planning: plan sprint
- Standup: 15-min sync
- Review: demo + feedback
- Retro: improve
- Refinement: clarify/estimate backlog`
         }
      ]
   },
   {
      id: 9,
      question: "Explain a widely used branching strategy",
      parts: [
         {
            type: "text",
            content: `**Branching Strategy — Git Flow**

- 🌿 main/master (prod), develop (integration)
- 🔧 feature/* from develop → merge back to develop
- 📦 release/* from develop → merge to main + develop
- 🚑 hotfix/* from main → merge to main + develop

Alternatives: GitHub Flow, trunk-based, GitLab Flow — choose based on team/release cadence.`
         }
      ]
   }
];

